<template>
  <div class="third-formOne userManage-details">
    <div class="formOne-btn">
      <div class="btn-left">
        <span class="left-back-icon" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          <span class="left-back-title">返回</span>
        </span>
        <span class="left-back-shu">
          <span class="left-back-shu-content"></span>
        </span>
        <span class="left-back-content">用户动态</span>
      </div>
      <div class="btn-right"></div>
    </div>
    <div class="head-info" style="margin-top: 57px;">
      <div class="item-title">
        <div class="item-title__head">
          <img :src="info.photo ? info.photo : 'img/head.jpg'" alt="">
        </div>
        <div class="item-title__name">
          <h3>{{ info.nickName }}</h3>
          <span>{{ info.campusName }}</span>
        </div>
      </div>
      <div class="info-box">
        <span>真实姓名：{{ info.realName }}</span>
        <span>学号/工号/账号：{{ info.account }}</span>
        <span>联系电话：{{ info.tel }}</span>
        <div>个性签名：{{ info.sign }}</div>
      </div>
    </div>

    <div class="details-box">
      <alumni
        v-for="(item, index) in alumniData"
        :key="index"
        :data="item"
        @shieldMethods="shieldMethods(item.id)"
        @delDiscuss="delDiscuss"
        :showLine="index === alumniData.length - 1"
      >
      </alumni>
      <div class="uploadBtn">
        <el-button v-if="alumniData.length > 0" plain @click="uploadData" :loading="loadingBtn">{{ uploadMsg }}</el-button>
        <div v-else style="font-size: 14px;">没有更多数据了...</div>
      </div>
    </div>

    <shield-modal
      :shieldModalVisible="shieldModal"
      :selectReasonList="selectReasonList"
      @agreeToShield="agreeToShield"
      @cancelShieldModal="cancelShieldModal">
    </shield-modal>
  </div>
</template>
<script>
import { removeStore, getStore } from "@/utils/store";
export default {
  data() {
    return {
      loadingBtn: false, // 加载按钮
      uploadMsg: '加载更多...',
      info: {},
      alumniData: [],
      shieldModal: false, // 屏蔽弹窗
      selectReasonList: [],
      shieldId: '',
      pageIndex: 1,
      pageSize: 20,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const userId = sessionStorage.getItem('detailsUserID');
      this.$store.dispatch('getUserDynamic', {
        userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then((res) => {
        console.log(res)
        if (res.data.status === 1000) {
          const { result } = res.data;
          this.info = result.records;
          this.alumniData = result.records.dynamics;
          this.alumniData.forEach((ele) => {
            ele.campusName =  this.info.campusName
          })
        }
      })
    },
    goBack() {
      if(sessionStorage.getItem("goBack")=="back"){
        this.$router.go(-1);//返回上一页
        return;
      }
      this.$emit("backHome");
    },
    // 屏蔽
    shieldMethods(id) {
      console.log(id);
      this.shieldId = id;
      this.shieldModal = true;
    },
    // 关闭屏蔽弹窗
    cancelShieldModal() {
      this.shieldModal = false;
    },
    // 确定屏蔽
    agreeToShield(fromData) {
      // console.log(fromData);
      this.$store.dispatch('shieldDynamics', {
        id: this.shieldId,
        reportId: fromData.reason,
        type: 0,
      }).then((res) => {
        if (res.data.status === 1000) {
          this.$message({
            message: '屏蔽成功！',
            type: 'success'
          });
          this.getData();
          this.shieldModal = false;
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    // 删除评论
    delDiscuss(id) {
      console.log(id);
      this.shieldId = id;
      this.shieldModal = true;
    },
    // 加载
    uploadData() {
      const { alumniData } = this
      this.loadingBtn = true;
      this.pageIndex++;
      const userId = sessionStorage.getItem('detailsUserID');
      this.$store.dispatch('getUserDynamic', {
        userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.data.status === 1000) {
          const { result } = res.data;
          if (result.records.dynamics.length === 0) {
            this.pageIndex--;
            this.uploadMsg = '没有更多数据了'
          } else {
            this.alumniData = alumniData.concat(result.records.dynamics)
            this.alumniData.forEach((ele) => {
              ele.campusName =  result.campusName
            })
          }
        } else {
          this.uploadMsg = '没有更多数据了'
          this.pageIndex--;
        }
      }).finally(() => this.loadingBtn = false)
    },
  }
}
</script>

<style lang="scss">
.userManage-details {
  background: none !important;
  height: auto !important;
  .head-info {
    font-size: 15px !important;
    padding: 20px 50px;
    background-color: #fff;
    // height: 135px;
    .item-title {
      display: flex;
      align-items: center;
      &__head {
        width: 50px;
        height: 50px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
        img {
          width: 100%;
        }
      }
      &__name {
        margin-right: 20px;
        h3 {
          margin: 0;
        }
        span {
          font-size: 12px;
          color: #999999;
        }
      }
    }
    .info-box {
      margin-top: 20px;
      font-size: 13px;
      padding-left: 60px;
      span {
        margin-right: 35px;
      }
      div {
        margin-top: 10px;
      }
    }
  }
  .details-box {
    margin: 8px;
    background-color: #fff;
    height: calc(100vh - 227px);
    overflow-y: auto;
    .uploadBtn {
      margin: 50px 0 30px 0;
      text-align: center;
    }
  }
}
</style>
